import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const EswatiniFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15973'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15973)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 2.8H20V0H0V2.8Z'
					fill='#486BCA'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V11.2H0V14Z'
					fill='#486BCA'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 11.2H20V2.80005H0V11.2Z'
					fill='#FFDF20'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 10.2666H20V3.73328H0V10.2666Z'
					fill='#CF1615'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0006 9.33329C12.3675 9.33329 14.2863 6.99996 14.2863 6.99996C14.2863 6.99996 12.3675 4.66663 10.0006 4.66663C7.63362 4.66663 5.71484 6.99996 5.71484 6.99996C5.71484 6.99996 7.63362 9.33329 10.0006 9.33329Z'
					fill='white'
				/>
				<mask
					id='mask1_2332_15973'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='5'
					y='4'
					width='10'
					height='6'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M10.0006 9.33329C12.3675 9.33329 14.2863 6.99996 14.2863 6.99996C14.2863 6.99996 12.3675 4.66663 10.0006 4.66663C7.63362 4.66663 5.71484 6.99996 5.71484 6.99996C5.71484 6.99996 7.63362 9.33329 10.0006 9.33329Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask1_2332_15973)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M10.4766 4.66663H5.71466V9.33329H9.52418L10.4766 4.66663Z'
						fill='#262626'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M10.9528 7.46666C11.2157 7.46666 11.4289 7.25772 11.4289 6.99999C11.4289 6.74226 11.2157 6.53333 10.9528 6.53333C10.6898 6.53333 10.4766 6.74226 10.4766 6.99999C10.4766 7.25772 10.6898 7.46666 10.9528 7.46666Z'
						fill='#1A1A1A'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M9.04846 7.46666C9.31145 7.46666 9.52465 7.25772 9.52465 6.99999C9.52465 6.74226 9.31145 6.53333 9.04846 6.53333C8.78546 6.53333 8.57227 6.74226 8.57227 6.99999C8.57227 7.25772 8.78546 7.46666 9.04846 7.46666Z'
						fill='#F6F6F6'
					/>
				</g>
			</g>
		</svg>
	);
};

export default EswatiniFlagIcon;
